import { updateFeed, quickEntries } from '@/mocks/home';

export default function UpdateBar() {
  const looped = [...updateFeed, ...updateFeed];

  return (
    <div className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto flex w-full flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:gap-6 md:px-6">
        <div className="flex shrink-0 items-center gap-2">
          <span className="relative flex h-2.5 w-2.5 items-center justify-center">
            <span className="absolute h-2.5 w-2.5 rounded-full bg-primary-500 animate-soft-pulse" />
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          </span>
          <span className="font-label text-sm font-semibold text-foreground-950">实时更新</span>
          <span className="font-label text-xs text-foreground-500">2026-09-12</span>
        </div>

        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max items-center gap-8 animate-marquee">
            {looped.map((text, index) => (
              <span key={`${text}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-600">
                <i className="ri-flashlight-fill text-accent-500" />
                {text}
              </span>
            ))}
          </div>
        </div>

        <div className="hidden shrink-0 items-center gap-2 lg:flex">
          {quickEntries.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className={item.icon} />
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}